import { setLanguage } from '@purple-start-registration/common/localization';

export function WithLanguage(Component) {
  return function Wrapper(props) {
    setLanguage(props.language);

    return (
      <>
        <Component {...props} />
      </>
    );
  };
}
